import styled, { css } from 'styled-components';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const AnchorWrapper = styled.div`
  text-align: right;
  
  a {
    ${breakpointsMedia({
    lg: css`
        margin-left: ${spacing('4x')};
      `,
  })}
  }
`;

AnchorWrapper.displayName = 'AnchorWrapper';
